import {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import InsuranceEmployment from './InsuranceEmployment'
import BarriersToOutcomes from './BarriersToOutcomes'
import PersonaEngagement from '../../../../api/queries/persona/PersonaEngagementQuery'
import {usePersona} from '../../../../store/hooks/persona'

const Engagement = ({handlePersonaCustomLabel}) => {
  const [engagementData, setEngagementData] = useState({
    unemploymentRisk: 0,
    uninsuranceRisk: 0,
    hospitalAccess: 0,
    pharmacyAccess: 0,
    transportationInsecurity: 0
  })

  const {personaEngagement, loadingPersonaEngagement, refetchPersonaEngagement, errorLoadingPersonaEngagement} =
    PersonaEngagement()

  const {personas} = usePersona()
  const [zeroCountPopulation, setZeroCountPopulation] = useState(false)

  useEffect(() => {
    if (!loadingPersonaEngagement) {
      const data = personaEngagement?.personaEngagement
      const allValuesNullOrZero = (obj) => {
        if (!obj) return true
        return Object.values(obj).every((val) => val === null || val === undefined || val === 0)
      }
      if (data !== undefined && data !== null && !allValuesNullOrZero(data)) {
        setEngagementData({
          unemploymentRisk: Math.round(data.unemploymentRisk),
          uninsuranceRisk: Math.round(data.uninsuranceRisk),
          hospitalAccess: Math.round(data.hospitalAccess),
          pharmacyAccess: Math.round(data.pharmacyAccess),
          transportationInsecurity: Math.round(data.transportationInsecurity)
        })
        setZeroCountPopulation(false)
      } else {
        setEngagementData({
          unemploymentRisk: 0,
          uninsuranceRisk: 0,
          hospitalAccess: 0,
          pharmacyAccess: 0,
          transportationInsecurity: 0
        })
        setZeroCountPopulation(true)
      }
    }
  }, [personaEngagement, loadingPersonaEngagement, errorLoadingPersonaEngagement])

  useEffect(() => {
    refetchPersonaEngagement()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personas])

  return (
    <>
      <InsuranceEmployment
        engagementData={engagementData}
        loadingPersonaEngagement={loadingPersonaEngagement}
        isZeroCountPopulation={zeroCountPopulation}
        handlePersonaCustomLabel={handlePersonaCustomLabel}
      />
      <BarriersToOutcomes
        engagementData={engagementData}
        isZeroCountPopulation={zeroCountPopulation}
        handlePersonaCustomLabel={handlePersonaCustomLabel}
      />
    </>
  )
}
Engagement.propTypes = {
  handlePersonaCustomLabel: PropTypes.func.isRequired
}

export default Engagement
